// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"_29OrYvfMUhaO3hHqqWg6A_","googleButton":"_5AjNr2h2ePmfJTPJHqGdb","fbButton":"_2tJKQDqk3Ve2g5sNYbGroP","widthWrapper":"_2ha99RNGJRsns6qWekRV8i","superWrapper":"_150F6IXMCccIvt1sUnNDMw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.scss
// module id = 1100
// module chunks = 0